import React from 'react';

const rowClass =
  'rounded-xl border border-white/10 bg-white/5 px-4 py-3 text-sm font-medium leading-relaxed text-white';

export default function CaseStudyDemo({ items = [], blocks = [] }) {
  if (!items.length && !blocks.length) return null;

  return (
    <div className="mt-5 space-y-3">
      {blocks.map((block) => (
        <div
          key={block.kicker}
          className={
            block.accent
              ? 'rounded-xl border border-[hsl(158_45%_48%)]/60 px-4 py-3'
              : rowClass
          }
        >
          <p className="text-xs font-semibold uppercase tracking-wider text-[hsl(158_40%_72%)]">
            {block.kicker}
          </p>
          <p className="mt-2 text-sm leading-relaxed text-white">{block.body}</p>
        </div>
      ))}
      {items.map((item) => (
        <p key={item} className={rowClass}>
          {item}
        </p>
      ))}
    </div>
  );
}
